var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgSkipPrev = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#skip_prev_svg__clip0_1442_3608)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M6 6h2v12H6V6Zm3.5 6 8.5 6V6l-8.5 6Zm6.5 2.14L12.97 12 16 9.86v4.28Z"
}))));
export default SvgSkipPrev;